export const projectPrefix = 'Origin';
